import React, { useCallback, useMemo, useState } from 'react';
import { Modal } from '@adc/parallax-component-library';
import { ApiStatus } from 'Enums';
import { Main, Spinner } from 'Components/utility';
import { INITIALIZATION_ERROR } from 'Reducers/nav/types';
import { notifyApp } from 'Utilities/appCommunicator';
import { _config } from 'Utilities/envConfig';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
import { store } from 'Utilities/store';
const InitializationErrorPage = ({ errorStatus }) => {
    const [loading, setLoading] = useState(false);
    const [isOpen, setIsOpen] = useState(true);
    const error = useMemo(() => {
        switch (errorStatus) {
            case ApiStatus.INTERNAL_SERVER_ERROR:
                return {
                    title: 'Global.modals.internetConnectionError.title',
                    message: 'Global.modals.internetConnectionError.body',
                };
            case ApiStatus.UNAUTHORIZED:
                return {
                    title: 'Global.modals.featureNotAvailable.title',
                    message: 'Global.modals.featureNotAvailable.body',
                    action: () => {
                        setLoading(true);
                        notifyApp('adc-webview:navigation');
                        setTimeout(() => {
                            setLoading(false);
                        }, 5000);
                    },
                };
            default:
                return {
                    title: 'Global.modals.internetConnectionError.title',
                    message: 'Global.modals.errorCommunicatingServer.body',
                };
        }
    }, [errorStatus]);
    const onClose = useCallback(() => {
        setIsOpen(false);
        if (error.action) {
            error.action();
            return;
        }
        setLoading(true);
        notifyApp('adc-webview:navigation');
        // Give the app some time to redirect the user back.
        setTimeout(() => {
            if (store) {
                store.dispatch({ type: INITIALIZATION_ERROR, initErrorStatus: 0 });
            }
            setLoading(false);
            if (_config.environment !== 'production') {
                mediator.publish('router:reload');
            }
        }, 5000);
    }, [error]);
    return (React.createElement(Main, null,
        loading && React.createElement(Spinner, null),
        React.createElement(Modal, { isOpen: isOpen, header: i18n.t(error.title), details: i18n.t(error.message), primaryAction: {
                label: i18n.t('Global.microcopy.common.okCap'),
                onPress: onClose,
            } })));
};
export default InitializationErrorPage;
